<template>
    <div class="home">
        <div class="is-pulled-right"><button class="button is-info is-small" @click="$emit('backToMenu')">Back Without Saving </button></div><br /><br />

        <div class="notification is-warning " v-if="loading==true">
            <p>Loading ...</p>
        </div>

        <div class="box" v-if="loading==false">	
              
           
            <form @submit.prevent="saveAccessNiPolicy">  
                <h4 class="title is-4">Access NI Policy</h4>
                    <p>As an applicant we would like you to confirm that you are aware of the following Access NI policies we have available when registering with {{ system_title }}</p>
                    <ul>
                        <li v-for="(link, index) in pdfLinks" :key="index">
                            <a :href="link.url" @click="markLinkAsClicked(index)" target="_blank">{{ link.name }}</a>
                        </li>
                        </ul>
                        
                    <div v-if="personal_details.access_ni_policy_acknowledged != '' && personal_details.access_ni_policy_acknowledged != null">
                        <strong>You have already confirmed this section</strong>
                    </div>
                    <div v-else>
                        
                        
                        <div class="field is-grouped">
                            <div class="control">
                                <button class="button is-success" type="submit" :disabled="!allLinksClicked || working == true" >I confirm I have read and understand all of the documents above</button>
                            </div>
                        </div>
                        
                    </div>
                </form>
            
          </div>
          
      </div>
  </template>

<script>
    import UtilityService from '@/services/UtilityService.js';
    import MemberApplicationService from '@/services/MemberApplicationService.js';
    
    export default {
      name: 'ViewApplication',
        mixins: [],
        props: ['application'],
        data: function () {
            return {
                   application_code : this.$route.params.id,
                   loading:false,
                   accessToken: '',
                   personal_details: [],
                   pdfLinks: [
                    { name: "Access NI Code of Practice", url: "https://balmoral.healthcare/wp-content/uploads/2025/05/For-Applicants-2025-Access-NI-Code-of-Practice.pdf" },
                    { name: "BHC Privacy Statement", url: "https://balmoral.healthcare/wp-content/uploads/2025/05/For-Applicants-2025-BHC-Privacy-Statement.pdf" },
                    { name: "Access NI Policy Acknowledgement", url: "https://balmoral.healthcare/wp-content/uploads/2025/05/For-Applicants-Access-NI-Policy-Acknowledgement-2025.pdf" },
                    { name: "Security Policy", url: "https://balmoral.healthcare/wp-content/uploads/2025/05/For-Applicants-Security-Policy.pdf" },
                    { name: "Recruitment of Ex-Offenders Policy", url: "https://balmoral.healthcare/wp-content/uploads/2025/05/For-Applicants-Recruitment-of-ex-offenders-policy-2025.pdf" },
                ],
                clickedLinks: [],
                system_title : process.env.VUE_APP_SYSTEM_TITLE,
            }
        },
        created() {
          this.getAccessNiPolicyDetails()
          
        },
        methods: {
            markLinkAsClicked(index) {
                if (!this.clickedLinks.includes(index)) {
                    this.clickedLinks.push(index);
                }
            },
            async getAccessNiPolicyDetails() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "web/applications/" + this.application_code + '/personal_details').then(
                    response => {
                        this.personal_details = response 
                        this.loading = false;
                    }
                );
            },
            async saveAccessNiPolicy() {
                
                this.working = true
                var formdata = { 
                    access_ni_policy_acknowledged : 1,
                }; 

                
                MemberApplicationService.saveAccessNiPolicy(this.accessToken, this.application_code, formdata)
                .then((response) => {
                    console.log(response)
                    this.$emit('backToMenu')
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                            alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        }
                        if(error.response.status === 406)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                            alert("The barcodes passed in were not valid. Please double check and try again.")
                        }
                        
                        this.working = false
                });
                

                
            },
            
           
        },
        computed: {
            allLinksClicked() {
            return this.clickedLinks.length === this.pdfLinks.length;
            }
        },
    }
    </script>